(function () {
  if (!window.location.pathname.includes("/products/")) return;

  const TARGET_SELECTOR = '[data-block-id="complementary_products_CxAR7h"]';
  const ANCHOR_ID = "hue-mini-review-module-anchor";
  const TEMPLATE_ID = "hue-mini-review-template";

  function ensureHueInserted(root) {
    if (document.getElementById(ANCHOR_ID)) return;

    const target = (root || document).querySelector(TARGET_SELECTOR);
    if (!target) return;

    const wrapper = document.createElement("div");
    wrapper.id = ANCHOR_ID;
    wrapper.setAttribute("data-hue-mini-review-anchor", "");

    target.parentNode.insertBefore(wrapper, target);

    const tpl = document.getElementById(TEMPLATE_ID);
    if (tpl && tpl.content) {
      wrapper.appendChild(tpl.content.cloneNode(true));
    }
  }

  function boot() {
    ensureHueInserted(document);

    const obs = new MutationObserver(function () {
      ensureHueInserted(document);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });

    let tries = 0;
    const maxTries = 40;
    const interval = setInterval(function () {
      ensureHueInserted(document);
      tries++;
      if (document.getElementById(ANCHOR_ID) || tries >= maxTries) {
        clearInterval(interval);
      }
    }, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

